﻿import DefaultApp from './defaultApp';
import ToggleTable from './components/toggleTable.vue';
import { useVuelidate } from '@vuelidate/core';
import { required, email, between, helpers } from '@vuelidate/validators';
import datePicker from 'vanillajs-datepicker/Datepicker';
import nl from 'vanillajs-datepicker/locales/nl';
Object.assign(datePicker.locales, nl);

const today = new Date();
const monthLater = new Date(today.setDate(today.getDate() + 31));
const iscurrency = helpers.regex(/^\d+([.,]\d{2})?$/);

const dateOptions = {
    autohide: true,
    format: 'dd-M-yyyy',
    maxDate: monthLater,
    minDate: new Date(),
    language: 'nl',
    nextArrow: '>',
    prevArrow: '<',
    orientation: 'top'
}

const payAgreementApp = {
    ...DefaultApp,
    components: {
        ToggleTable
    },
    setup: () => ({ v$: useVuelidate() }),
    data() {
        return {
            ...DefaultApp.data(),
            api: '',
            postApi: '',
            invoices: [],
            invoiceschosen: [],
            startdate: '',
            amount: '',
            email: '',
            user: {},
            loading: false,
            sendSuccess: false,
            changeEmail: false
        }
    },
    validations() {
        return {
            invoiceschosen: { required },
            startdate: {
                required,
                between(date) {
                    let dateObj = this.getDateFromString(date);
                    let td = new Date();
                    let yd = td.setDate(td.getDate() - 1);
                    return dateObj >= yd && dateObj < monthLater
                }
            },
            amount: {
                required,
                iscurrency,
                minValue: (value) => {
                    return parseFloat(value.replace(/\s/g, "").replace(",", ".")) > 1;
                }
            },
            email: {
                required,
                email
            }
        }
    },
    computed: {
        totalAmount() {
            return this.invoices.reduce((accumulator, invoice) => accumulator + invoice.amount, 0);
        },
        totalChosen() {
            return this.chosenInvoicesList.reduce((accumulator, invoice) => accumulator + invoice.amount, 0);
        },
        chosenInvoicesList() {
            return this.invoices.filter(({ id }) => this.invoiceschosen.includes(id));
        }
    },
    methods: {
        ...DefaultApp.methods,
        async init() {
            this.loading = true;
            if (sessionStorage.getItem('user') === null) {
                this.generalError = true;
            } else {
                this.user = JSON.parse(sessionStorage.getItem('user'));
                if (this.user.email) this.email = this.user.email;
            }
            let invoicesResponse = await this.fetchData({}, this.api, 'get');
            if (invoicesResponse.status === 200) {
                this.invoices = invoicesResponse.data.items;
                if (this.invoices.length) {
                    this.$nextTick(() => {
                        if (this.$refs.datepicker) {
                            let format = this.$refs.datepicker.dataset.showformat;
                            dateOptions.format = format;
                            new datePicker(this.$refs.datepicker, dateOptions);
                            this.$refs.datepicker.addEventListener('changeDate', (e) => {
                                this.$refs.datepicker.dispatchEvent(new Event('input', { bubbles: true }));
                            });
                        }
                    });
                }
            } else {
                this.generalError = true;
            }
            this.loading = false;
        },
        async submit() {
            let isValid = await this.v$.$validate();
            if (isValid) {
                let data = {
                    DossierNummers: this.invoiceschosen,
                    Start: this.getDateFromString(this.startdate).toISOString(),
                    Amount: parseFloat(this.amount.replace(',','.')),
                    Email: this.email,
                    SetEmailForContact: this.changeEmail
                }
                const response = await this.fetchData(data, this.postApi, 'post');
                if (response.status === 200) {
                    this.sendSuccess = true;
                } else {
                    this.generalError = true;
                }
            }
        }
    },
    mounted() {
        if (this.$el.parentNode.dataset.apiurl) this.api = this.$el.parentNode.dataset.apiurl;
        if (this.$el.parentNode.dataset.posturl) this.postApi = this.$el.parentNode.dataset.posturl;
        this.init();
    }
}


export default payAgreementApp;